import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import { Player } from 'ThreeTerminal_pc_dynamic';
import { Player } from 'ThreeTerminal_pc';
import { formatImageAblur } from '@ifeng-fe/public_method';

let autoPlay = true;

if (typeof document !== 'undefined' && cookie.get('autoplay') === 'no') {
    autoPlay = false;
}

const PLAYER_WIDTH = 480;
const MIN_RATIO = 3 / 4;
const MAX_RATIO = 16 / 9;

const getPlayerHeightByAspect = (aspect) => {
    if (!aspect || typeof aspect !== 'string' || !aspect.includes(':')) {
        return 380;
    }

    const [videoWidth, videoHeight] = aspect.split(':').map((item) => Number(item));

    if (!videoWidth || !videoHeight) {
        return 380;
    }

    const ratio = videoWidth / videoHeight;
    const clampedRatio = Math.min(MAX_RATIO, Math.max(MIN_RATIO, ratio));

    return Math.round(PLAYER_WIDTH / clampedRatio);
};

class Video extends React.PureComponent {
    static propTypes = {
        topic: PropTypes.string,
        videoinfo: PropTypes.object,
        pluginData: PropTypes.object,
    };

    state = {
        checked: autoPlay,
    };

    playermsg = {
        width: PLAYER_WIDTH,
        height: 380,
        isAuth: 'auth',
        autoPlay,
        showAdBehind: true,
        adType: '1',
        isInsertArticle: true
    };

    handleChange = () => {
        const { checked } = this.state;

        if (!checked) {
            cookie.set('autoplay', 'yes');
        } else {
            cookie.set('autoplay', 'no');
        }

        this.setState({
            checked: !checked,
        });
    };

    render() {
        const { checked } = this.state;
        const { topic, videoinfo, videoConfig, pluginData } = this.props;
        const currentVideoConfig = videoConfig || videoinfo;
        const playerHeight = getPlayerHeightByAspect(this.props.videoConfig?.aspect || videoinfo?.aspect);

        this.playermsg.height = playerHeight;

        if (topic !== '') {
            this.playermsg = { ...this.playermsg, subject: topic };
        }

        currentVideoConfig.bigPosterUrl = (currentVideoConfig.bigPosterUrl && formatImageAblur(currentVideoConfig.bigPosterUrl, PLAYER_WIDTH, playerHeight)) || '';


        return (
            <div
                className={styles.video_box}
                style={{
                    width: pluginData?.isMiddle ? 'auto' : '',
                    background: pluginData?.isMiddle ? 'none' : '',
                }}>
                <div className={styles.video}>
                    <Player videoConfig={currentVideoConfig} playermsg={this.playermsg} />
                </div>
                {pluginData?.isMiddle ? null : (
                    <>
                        <input type="checkbox" checked={checked ? 'checked' : ''} onChange={this.handleChange} />
                        <span>自动播放</span>
                    </>
                )}
            </div>
        );
    }
}

export default errorBoundary(Video);
